/**
 * External dependencies
 */
import { ButtonControls } from '~cartzillagb/components'
import { __getValue } from '~cartzillagb/util'
import { camelCase } from 'lodash'

/**
 * WordPress dependencies
 */
import { sprintf } from '@wordpress/i18n'

const ButtonControlsHelper = props => {
	const { setAttributes } = props
	const getAttrName = attrName => camelCase( sprintf( props.attrNameTemplate, attrName ) )
	const getValue = __getValue( props.blockAttributes, getAttrName, '' )

	return (
		<ButtonControls
			design={ props.blockAttributes[ getAttrName( 'Design' ) ] || '' }
			url={ props.blockAttributes[ getAttrName( 'Url' ) ] || '' }
			size={ props.blockAttributes[ getAttrName( 'Size' ) ] || '' }
			animation={ props.blockAttributes[ getAttrName( 'Animation' ) ] || '' }
			delay={ props.blockAttributes[ getAttrName( 'Delay' ) ] || '' }
			backgroundColor={ props.blockAttributes[ getAttrName( 'BackgroundColor' ) ] || '' }
			shadow={ props.blockAttributes[ getAttrName( 'Shadow' ) ] }
			buttonIcon={ props.blockAttributes[ getAttrName( 'Button Icon' ) ] }
			icon={ props.blockAttributes[ getAttrName( 'Icon' ) ] || '' }
			shape={ props.blockAttributes[ getAttrName( 'Shape' ) ] || '' }
			iconAfterText={ props.blockAttributes[ getAttrName( 'IconAfterText' ) ] || '' }
			newTab={ props.blockAttributes[ getAttrName( 'NewTab' ) ] || '' }
			noFollow={ props.blockAttributes[ getAttrName( 'NoFollow' ) ] || '' }

			onChangeNewTab={ value => setAttributes( { [ getAttrName( 'NewTab' ) ]: value } ) }
			onChangeNoFollow={ value => setAttributes( { [ getAttrName( 'NoFollow' ) ]: value } ) }
			onChangeDesign={ value => setAttributes( { [ getAttrName( 'Design' ) ]: value } ) }
			onChangeUrl={ value => setAttributes( { [ getAttrName( 'Url' ) ]: value } ) }
			onChangeSize={ value => setAttributes( { [ getAttrName( 'Size' ) ]: value } ) }
			onChangeAnimation={ value => setAttributes( { [ getAttrName( 'Animation' ) ]: value } ) }
			onChangeDelay={ value => setAttributes( { [ getAttrName( 'Delay' ) ]: value } ) }
			onChangeBackgroundColor={ value => setAttributes( { [ getAttrName( 'BackgroundColor' ) ]: value } ) }
			onChangeShadow={ value => setAttributes( { [ getAttrName( 'Shadow' ) ]: value } ) }
			onChangeButtonIcon={ value => setAttributes( { [ getAttrName( 'Button Icon' ) ]: value } ) }
			onChangeIcon={ value => setAttributes( { [ getAttrName( 'Icon' ) ]: value } ) }
			onChangeShape={ value => setAttributes( { [ getAttrName( 'Shape' ) ]: value } ) }
			onChangeiconAfterText={ value => setAttributes( { [ getAttrName( 'IconAfterText' ) ]: value } ) }
			{ ...props }
		/>
	)
}

ButtonControlsHelper.defaultProps = {
	attrNameTemplate: '%s',
	setAttributes: () => {},
	blockAttributes: {},
}

export default ButtonControlsHelper